const ASAAS_FILTERS_TO_REMOVE_FROM_PARAMS = ['dueDateStart', 'dueDateEnd']

export function formatAsaasFilters(filters) {
  const rest = { ...filters }
  ASAAS_FILTERS_TO_REMOVE_FROM_PARAMS.forEach(key => {
    delete rest[key]
  })
  return rest
}
